export default "__VITE_ASSET__Bn81elXA__"